import React from 'react';
import { CreateProductForm } from '../../modules';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const NewProductView = () => (
    <EditScreenLayout path={routePaths.products}>
        <CreateProductForm />
    </EditScreenLayout>

);

export default NewProductView;
